import type React from 'react';

interface TimeDisplayProps {
  hour: number;
  minute: number;
  className?: string;
  format?: '12h' | '24h';
  showSeconds?: boolean;
}

const getDisplayHour = (hour: number): number => {
  if (hour === 0) {
    return 12;
  }
  if (hour > 12) {
    return hour - 12;
  }
  return hour;
};

export const TimeDisplay: React.FC<TimeDisplayProps> = ({
  hour,
  minute,
  className = '',
  format = '12h',
}) => {
  const formatTime = () => {
    if (format === '24h') {
      const displayMinute = minute.toString().padStart(2, '0');
      return `${hour.toString().padStart(2, '0')}:${displayMinute}`;
    }
    
    // 12h format
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = getDisplayHour(hour);
    const displayMinute = minute.toString().padStart(2, '0');
    return `${displayHour}:${displayMinute} ${period}`;
  };

  return (
    <span className={`font-mono text-sm ${className}`}>
      {formatTime()}
    </span>
  );
};